import http from './config'

export default {
  salvaOperacao: (dadosProposta) => {
    return http.post('/api/v1/operacao', dadosProposta)
  },
  confirma: (dadosConfirmacao) => {
    return http.put(`/api/v1/operacao/confirmacao?idOperacao=${dadosConfirmacao.idOperacao}`)
  },
  listarOpcoes: () => {
    return http.get('/api/v1/operacao/opcoes')
  }
}
